
import React from 'react';
import { CycleImportRow } from '@/utils/cycle-tracking/import';
import DataPreview from '../preview/DataPreview';

interface DataPreviewSectionProps {
  parsedData: CycleImportRow[];
}

const DataPreviewSection: React.FC<DataPreviewSectionProps> = ({ parsedData }) => {
  if (parsedData.length === 0) {
    return null;
  }
  
  return <DataPreview parsedData={parsedData} />;
};

export default DataPreviewSection;
